module.exports = __webpack_public_path__ + "static/media/closeRedPlain.a520ea79.svg";